import { Component, OnInit } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { SubmitInsuranceModalComponent } from '../modals/submit-insurance-modal/submit-insurance-modal.component'

import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService } from '../../services/analytics.service'

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FaqComponent implements OnInit 
{
  t1n10Visible = false
  t1n11Visible = false
  t1n12Visible = false
  t1n18Visible = false
  t1n19Visible = false
  t1n20Visible = false
  t1n21Visible = false
  t2n13Visible = false
  t2n14Visible = false
  t2n15Visible = false
  t2n21Visible = false
  t2n22Visible = false
  t2n23Visible = false
  t2n24Visible = false
  t2n25Visible = false
  t2n26Visible = false
  t3n16Visible = false
  t3n17Visible = false
  t3n27Visible = false
  t3n28Visible = false
  t4n29Visible = false
  t4n30Visible = false
  t4n31Visible = false
  t4n32Visible = false
  t4n33Visible = false
  t4n34Visible = false

  constructor(
    public dialog: MatDialog,
    public translateService: TranslateService,
    public analyticsService: AnalyticsService
  ) 
  { 
  }

  ngOnInit() 
  {
  }

  backToTop()
  {
    window.scrollTo(0, 0)
  }

  submitInsuranceInfo()
  {
    this.analyticsService.trackEvent('submit_insurance_button_click', { 
      button_name: 'submit_Insurance' 
    })

    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '1000px',
    this.dialog.open(SubmitInsuranceModalComponent, dialogConfig)
  }

  onInsuranceEmailClick() 
  {
    this.analyticsService.trackEvent('faq_insurance_email_click', {
      email_address: 'insurance@cdlsi.com',
      link_location: 'faq_insurance'
    })
  }

  onAssuranceEmailClick() 
  {
    this.analyticsService.trackEvent('faq_insurance_email_click', {
      email_address: 'assurance@cdlsi.com"',
      link_location: 'faq_insurance'
    })
  }

}
